export const shopLocalisationSettingsCacheKey = 'shopLocalisationSettings'
export const priceRulesCacheKey = 'priceRules'
export const priceRulesSettingsCacheKey = 'priceRulesSettings'
